"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _logger = _interopRequireDefault(require("./utils/logger"));

var _misc = require("./utils/misc");

var _unloadBehavior = require("./unloadBehavior");

var _constants = require("./constants");

// Send the API into the global scope, for external usage:
var legacyGlobalizeApi = function legacyGlobalizeApi(client, namespace) {
  // Set up global command queue, and execute any events that had already amassed:
  var cmdExecute = function cmdExecute(fn) {
    try {
      fn(client);
    } catch (e) {
      _logger["default"].error(e);
    }
  };

  var commandKey = (0, _misc.getCommandKey)(namespace);
  var win = window;
  win[commandKey] = win[commandKey] || [];
  var globalApiInitialized = win[commandKey].rswInitialized;
  win[commandKey].forEach(cmdExecute);
  win[commandKey].push = cmdExecute;

  if (!globalApiInitialized) {
    win[commandKey].rswInitialized = true; // Send all unsent cached events as user leaves page:

    window.addEventListener('beforeunload', _unloadBehavior.unloadBehavior);
  }
};

var globalizeApi = function globalizeApi(client, namespace) {
  // Account for server-side render:
  if ((0, _misc.noWindow)()) {
    return;
  }

  legacyGlobalizeApi(client, namespace);
  window._rswClients = window._rswClients || {};
  window._rswClients[namespace || _constants.DEFAULT_NAMESPACE] = client;
};

var _default = globalizeApi;
exports["default"] = _default;